import { v4 as uuidv4 } from 'uuid';

export function CheckoutSummaryCompact(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'CheckoutSummaryCompact',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
